/* @flow */
import { takeLatest, call, put, fork, all } from 'redux-saga/effects'
import { error } from 'react-notification-system-redux'

import {
  GET_SCENES,
  GET_SCENES_SUCCESS,
  GET_SCENES_FAILURE,
  // SET_VIEW_SCENE,
  CLOUD_SCENES_IMG_FOLDER,
} from '../configs/constants'
import API from '../libs/api'

const api = new API()

/* Workers */
export function* fetchScenes() {
  try {
    const [locations] = yield all([
      call([api, api.readDBOnce], '/locations'),
      // call(fetch, 'https://ttcloud.taitung.gov.tw/queryData/225', {
      //   body: JSON.stringify({'token': 'RFpxMP36daDD'}),
      //   method: 'POST',
      //   headers: {
      //     "content-type": "application/json"
      //   }
      // })
    ])
    // const result = yield aedResponse.json()
    // const aedList = result.data
    for (let key in locations) {
      const location = locations[key]
      // let tmp_aedList = _.filter(aedList, (item) => item['場所區域'].indexOf(location.name.cht) >= 0)
      // // Convert address to latlng using Google Map API
      // const responseList = yield all( _.map(tmp_aedList, (item) => call(fetch, 'https://maps.googleapis.com/maps/api/geocode/json?address='+item['場所地址']+'&key=AIzaSyBHxlOLpVX_WY5KvAOz9nTQicUEIk8ozfI')) )
      // const latlngList = yield all( _.map(responseList, (respons) => respons.json()) )
      // location.aedList = _.map(tmp_aedList, (item, idx) => {
      //   return { ...item, latlng: latlngList[idx].results[0].geometry.location }
      // })
      if (location.scenes) {
        for (let scene of location.scenes) {
          scene.thumb = yield call([api, api.getStorageUrl], CLOUD_SCENES_IMG_FOLDER + scene.preview)
        }
      }
    }
    yield put({ type: GET_SCENES_SUCCESS, locations })
  } catch (err) {
    yield put(error({ message: err.message}))
    yield put({ type: GET_SCENES_FAILURE, err })
  }
}

/* Watchers */
function* sceneWatcher() {
  yield takeLatest(GET_SCENES, fetchScenes)
}

export default [
  fork(sceneWatcher),
]


// WEBPACK FOOTER //
// ./src/sagas/sceneSaga.js